module.exports = __webpack_public_path__ + "static/img/logos_220px_pandatv.67b8e34.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/cooperation/img/network/logos_220px_pandatv.png
// module id = 4cH3
// module chunks = 0